exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/promotiondiscountaddbulk/promotiondiscountaddbulk.component.css
// module id = ../../../../../src/app/shared/component/promotiondiscountaddbulk/promotiondiscountaddbulk.component.css
// module chunks = main